<template>
  <div class="no-access-wrapper" style="display:flex;align-items:center;justify-content:center;height:100vh;text-align:center;">
    <div>
      <h2>Access Restricted</h2>
      <p>You can only open this page from our app.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotAllowed",
};
</script>